import { Component, inject } from "@angular/core";
import { ExportBase } from "../export-base";
import { ExportType } from "@enums/ExportType";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { StandingdataDataService } from "@app/standingdata/shared/standingdata.service";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ModuleType } from "@enums/ModuleType";
import { EventsRisksAndControlsModel } from "@app/export/shared/models/events-risks-and-controls-model";
import { nameof } from "@methods/jeffs-toolkit";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { injectTranslation, TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/export/i18n/scope";

@Component({
    selector: "export-events",
    templateUrl: "./export-events.component.html",
    styleUrls: ["./export-events.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe, FormsModule, MatCheckboxModule]
})
export class ExportEventsComponent extends ExportBase {
    permService = inject(PermissionsService);
    private cerrixPrompt = inject(CerrixPromptService);
    private dataService = inject(StandingdataDataService);
    private _translation = injectTranslation(scope);

    includeChecked = false;

    downloadEvent(type: ExportType) {
        const extra = `includedeletedandclosedmois=${this.includeChecked}`;
        this.exportDataService.downloadExport(type, extra);
    }

    async exportEventsRisksAndControls(): Promise<void> {
        await this._translation.ready();
        this.cerrixPrompt
            .prompt({
                height: "fit-content",
                data: {
                    title: this._translation.t("events.eventsRisksControlsTitle"),
                    message: this._translation.t("selectOrgsMessage"),

                    fields: [
                        {
                            prettyName: this._translation.t("organizationsField"),
                            fieldName: nameof<EventsRisksAndControlsModel>((x) => x.organizations),
                            fieldType: GenericListFieldType.MultiTree,
                            minLength: 1,
                            maxLength: 200,
                            required: true,
                            selfInit: true,
                            getDataMethod: () => {
                                return this.dataService.getOrganizations(ModuleType.LER);
                            },
                        },
                    ],
                    confirmButton: {
                        text: this._translation.t("downloadButton"),
                        icon: "fad fa-cloud-download",
                    },
                },
            })
            .toPromise()
            .then((result: EventsRisksAndControlsModel) => {
                if (!result) {
                    return;
                }

                const stringSections: string[] = [];
                if (result.organizations && result.organizations.length > 0) {
                    stringSections.push("organizations=" + result.organizations.join(";"));
                }

                const extraString = stringSections.length > 0 ? stringSections.join("&") : "";
                this.download(this.ExportType.EventsRisksAndControls, extraString);
            });
    }
}
